export function computeDashboardRange(period = 'last 30 days') {
  const today = new Date();
  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const start = new Date(end);

  const setDaysAgo = (n) => {
    const d = new Date(end);
    d.setDate(end.getDate() - n);
    return d;
  };

  switch (period) {
    case 'today':
      break;
    case 'month to date':
      start.setDate(1);
      break;
    case 'year to date':
      start.setMonth(0, 1);
      break;
    case 'yesterday': {
      const y = setDaysAgo(1);
      start.setTime(y.getTime());
      end.setTime(y.getTime());
      break;
    }
    case 'last 7 days':
      start.setTime(setDaysAgo(6).getTime());
      break;
    case 'last 14 days':
      start.setTime(setDaysAgo(13).getTime());
      break;
    case 'last 30 days':
    default:
      start.setTime(setDaysAgo(29).getTime());
      break;
  }

  return { start: toLocalDateKey(start), end: toLocalDateKey(end) };
}

export function isWithinInclusiveDateRange(value, startDate, endDate) {
  if (!value) return false;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;

  const localDay = toLocalDateKey(date);
  if (startDate && localDay < startDate) return false;
  if (endDate && localDay > endDate) return false;
  return true;
}

export function buildLocalDateRangeUtcFilter(startDate, endDate) {
  const filter = {};
  const start = parseLocalDateKey(startDate);
  const end = parseLocalDateKey(endDate);

  if (start) {
    filter.gte = start.toISOString();
  }

  if (end) {
    const exclusiveEnd = new Date(end);
    exclusiveEnd.setDate(end.getDate() + 1);
    filter.lt = exclusiveEnd.toISOString();
  }

  return Object.keys(filter).length > 0 ? filter : undefined;
}

function parseLocalDateKey(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime())
      ? null
      : new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    const date = new Date(value);
    return Number.isNaN(date.getTime())
      ? null
      : new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

function toLocalDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
